<template>
  <div class="online-interaction" id="app">
    <!-- 使用 Element UI 的 Loading 服务 -->
    <!-- <el-loading :loading="isLoading" text="正在加载离线消息..."></el-loading> -->
    <el-container style="height: 100%;" v-loading="isLoading" element-loading-text="正在加载离线消息..."
      element-loading-spinner="el-icon-loading">
      <el-aside width="250px" style="background-color: #f5f7fa;">
        <friend-list :className="className" :classPlaceholder="classPlaceholder" :classes="classes" :friends="friends"
          :activeFriend="activeFriend" @select-friend="handleSelect" @filter-class="filterClass"
          @search-student="searchStudent"></friend-list>
      </el-aside>
      <el-main style="padding: 20px 0;">
        <chat-history :messages="chatHistory"></chat-history>
        <chat-input v-model="newMessage" @send-message="sendMessage"></chat-input>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import FriendList from './components/friend-list/friendList.vue';
import ChatHistory from './components/chat-history/chatHistory.vue';
import ChatInput from './components/chat-input/chatInput.vue';
import { connect, sendMessage, onMessage, onClose } from '../../common/wssocket.js';
import { websocketIP } from "@/api/request"; // 服务器地址
import { Loading } from 'element-ui';

export default {
  components: {
    FriendList,
    ChatHistory,
    ChatInput
  },
  data() {
    return {
      friends: [],
      activeFriend: '',
      chatHistory: [],
      newMessage: '',
      // 处理后的班级年级多选数据
      classes: [],
      // 班级年级数据
      classSelectList: [],
      classId: '',
      searchName: '',
      className: [],
      classPlaceholder: '请选择班级',
      isLoading: false, // 控制加载状态
      mindId: parseInt(localStorage.getItem('mindId')) || 0, // 存储最新的mindId
      checkMindIdTimer: null, // 定时器，用于检查mindId是否发生变化
      lastCheckTime: Date.now(), // 上次检查的时间戳
      changeTimeoutDuration: 500, // 检测变化后等待的时间（毫秒）
      // loadingInstance: null,
    };
  },
  created() {
    // 获取年级班级
    this.selectSchoolAndGradeAndClassListPC();
    // 拉取离线消息，如果尚未拉取过
    if (localStorage.getItem("hasPulledOfflineMessages") == 'false') {
      this.pullOfflineMessage();
      this.startCheckingMindIdChanges(); // 开始检查 mindId 的变化
      localStorage.setItem("hasPulledOfflineMessages", true);
    };
    //  本地IP使用ws, 线上使用wss
    connect(`wss://${websocketIP}:8878/im`, JSON.parse(window.localStorage.getItem('local_userInfo')).accessToken);
    // connect(`ws://${websocketIP}:9123/im`, JSON.parse(window.localStorage.getItem('local_userInfo')).accessToken);
    onMessage((cmd, data) => {
      // console.log(cmd, data)
      if (data.type == 30) return;
      if (cmd === 3) { // 假设 cmd 2 是接收消息的命令
        if (data.parentId == this.activeFriend) {
          this.chatHistory.push({ sender: data.sender, text: data.content });
          // console.log("this.chatHistory：", this.chatHistory);

          this.scrollToBottom();
        };
      }
    });
    onClose(() => {
      // console.log('Connection closed');
    });
  },
  watch: {
    chatHistory(newVal) {
      this.saveChatHistory();
    }
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.checkMindIdTimer);
  },
  methods: {
    startCheckingMindIdChanges() {
      this.showLoading();
      this.checkMindIdTimer = setInterval(() => {
        const newMindId = parseInt(localStorage.getItem('mindId')) || 0;
        if (newMindId !== this.mindId) {
          this.mindId = newMindId;
          this.lastCheckTime = Date.now();
        } else if (Date.now() - this.lastCheckTime > this.changeTimeoutDuration) {
          // 如果超过指定时间没有变化，停止加载动画
          this.hideLoading();
          clearInterval(this.checkMindIdTimer); // 停止定时器
        }
      }, 1000); // 每100毫秒检查一次
    },
    showLoading() {
      this.isLoading = true; // 设置加载状态为true
      // 使用 Element UI 的 Loading 服务
      // this.loadingInstance = Loading.service({ fullscreen: true, text: '正在加载离线消息...' });
    },
    hideLoading() {
      this.isLoading = false; // 设置加载状态为false
      // 关闭 Loading 服务
      // if (this.loadingInstance) {
      //   this.loadingInstance.close();
      // }
    },
    pullOfflineMessage() {
      let data = {
        // classId:
        // studentId:
        minId: parseInt(localStorage.getItem('mindId')) || 0
      };
      this.get(this.$url.pullOfflineMessage, data).then(res => {
        // console.log("拉取离线消息", res);
      })
    },
    filterClass(e) {
      this.activeFriend = '';
      if (e.length) {
        this.classId = e[1].classId;
      } else {
        this.classId = "";
      };
      this.selectPatriarchInfoByClassId();
    },
    searchStudent(query) {
      this.searchName = query;
      this.selectPatriarchInfoByClassId();
    },
    // 年级和班级选择列表
    selectSchoolAndGradeAndClassListPC() {
      this.get(this.$url.getgradeList, {
        schoolId: this.user.schoolId,
      })
        .then((res) => {
          if (res.code !== 200) {
            return this.$message.error(res.msg);
          }
          // console.log(res);
          this.classSelectList = res.data;
          if (this.classSelectList.length) {
            this.classSelectList.forEach((gItem, g) => {
              let { gradeId, gradeName } = gItem;
              gItem.value = {
                gradeId,
                gradeName,
              };
              gItem.label = gItem.gradeName;
              gItem.schoolClassList.forEach((cItem, c) => {
                let { classId, className } = cItem;
                cItem.value = {
                  classId,
                  className,
                };
                cItem.label = cItem.className;
              });
            });
            this.classes = this.classSelectList;

            // 默认选中
            let firstGrade = {};
            let { gradeCode, gradeId, gradeName } = this.classes[0];
            firstGrade = { gradeCode, gradeId, gradeName };
            let firstClass = {};
            let { classCode, classId, className } =
              this.classes[0].schoolClassList[0];
            firstClass = { classCode, classId, className };
            this.className = [firstGrade, firstClass];
            this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
            // 默认第一个classId
            this.classId = this.classes[0].schoolClassList[0].classId;
            // 获取列表
            this.selectPatriarchInfoByClassId();
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$message.error("获取班级列表失败");
        });
    },
    selectPatriarchInfoByClassId() {
      this.post(this.$url.selectPatriarchInfoByClassId, {
        classId: this.classId,
        name: this.searchName,
        pageNum: 1,
        pageSize: 9999,
      }).then(res => {
        // console.log("获取家长列表==>", res);
        // 假设 res.rows 是这样的数据结构
        let rows = res.rows;

        if (!rows) {
          this.chatHistory = [];
          this.friends = [];
          return;
        };

        // 创建一个Map来存储已经遇到的 patriarchId
        let seenPatriarchIds = new Map();

        rows.forEach(row => {
          // 如果 Map 中还没有这个 patriarchId，则添加到 Map 中
          if (!seenPatriarchIds.has(row.patriarchId)) {
            seenPatriarchIds.set(row.patriarchId, row);
          }
        });

        // 使用 Map 的 values() 方法获取过滤后的结果
        this.friends = Array.from(seenPatriarchIds.values());
        // this.activeFriend = '' + this.friends[0].patriarchId;
        this.loadChatHistory();
      });
    },
    handleSelect(friendId) {
      this.activeFriend = friendId;
      this.loadChatHistoryForFriend(friendId);
      this.scrollToBottom();
    },
    sendMessage() {
      if (!this.newMessage.trim()) return;
      // const message = {
      //   cmd: 2, // 假设 cmd 2 是发送消息的命令
      //   data: {
      //     receiver: this.activeFriend,
      //     message: this.newMessage
      //   }
      // };
      let parentInfo = this.friends.find(item => item.patriarchId == this.activeFriend);

      let data = {
        "schoolId": this.school.id,
        "schoolName": this.school.schoolName,
        "parentId": parentInfo.patriarchId,
        "parentName": parentInfo.name ? parentInfo.name : parentInfo.studentName + '家长',
        "teacherId": this.user.id,
        "teacherName": this.user.teacherName,
        "content": this.newMessage,
        "contentType": "0",
        "sender": this.user.id,
        "receiver": parentInfo.patriarchId
      };

      this.post(this.$url.sendMessage, data).then(res => {
        // console.log("发送消息==>", res);
        if (res.code !== 200) {
          this.$message.error(res.msg);
          return
        };
        this.chatHistory.push({ sender: 'teacher', text: this.newMessage, parentId: this.activeFriend });
        localStorage.setItem('mindId', res.data.id);
        // this.pullOfflineMessage();
        this.newMessage = '';
        this.saveChatHistory();
        this.scrollToBottom();
        // sendMessage(message);
      });
    },
    loadChatHistory() {
      this.chatHistory = [];
      // Load chat history from local storage
      let chatRecords = localStorage.getItem(`chatRecords${this.user.id}`);
      if (chatRecords) {
        chatRecords = JSON.parse(chatRecords);
        let selectedFriend = this.friends.find(friend => friend.patriarchId == this.activeFriend);
        if (selectedFriend && chatRecords[selectedFriend.name]) {
          this.chatHistory = chatRecords[selectedFriend.name];
        }
      }
    },
    loadChatHistoryForFriend(friendId) {
      this.activeFriend = friendId;
      this.loadChatHistory();
    },
    saveChatHistory() {
      if (!this.chatHistory.length) return;
      let chatRecords = localStorage.getItem(`chatRecords${this.user.id}`);
      if (chatRecords) {
        chatRecords = JSON.parse(chatRecords);
      } else {
        chatRecords = {};
      }

      let selectedFriend = this.friends.find(friend => friend.patriarchId == this.activeFriend);
      if (selectedFriend) {
        chatRecords[selectedFriend.name] = this.chatHistory;
        localStorage.setItem(`chatRecords${this.user.id}`, JSON.stringify(chatRecords));
        // console.log("Chat records saved successfully.", chatRecords);
      } else {
        console.error("No matching friend found for activeFriend:", this.activeFriend);
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = document.querySelector('.chat-history');
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  },
};
</script>

<style lang="scss">
/* Add your global styles here */
@import "./onlineInteraction.scss";
</style>
